var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMCuisse3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 178,
    viewBox: "0 0 145 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.167 177.047C135.296 129.058 134.312 82.6221 129.276 49.2042C125.02 20.9703 124.026 13.6626 122.736 0.0471258",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.047 71.7527C139.047 71.7527 144.255 99.3099 139.047 135.932",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeDasharray: "3.97 3.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9188 177.047C8.78902 129.058 9.77312 82.6221 14.8099 49.2042C19.0654 20.9703 20.0595 13.6626 21.3491 0.0471258",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03757 71.7527C5.03757 71.7527 -0.169828 99.3099 5.03757 135.932",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeDasharray: "3.97 3.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCuisse3);
export default __webpack_public_path__ + "static/media/M-CUISSE_3.a1c8dfc67ac9172f62400823529643e3.svg";
export { ForwardRef as ReactComponent };